import React, { createContext, useContext, ReactNode, useState } from 'react';
import { useModal } from '@grnhse/seedling/lib/birch/components/modals';
import { RejectionCategory } from '../../candidate_profile_redesign/modals/reject/reject_modal';

type RejectModalProps = {
  rejectionCategory?: RejectionCategory;
};

type RejectModalContextType = {
  rejectIsOpen: boolean;
  openReject: (props?: RejectModalProps) => void;
  closeReject: () => void;
  rejectModalProps: RejectModalProps;
};

const RejectModalContext = createContext<RejectModalContextType | undefined>(
  undefined
);

export const useRejectModal = () => {
  const context = useContext(RejectModalContext);
  if (!context) {
    throw new Error('useRejectModal must be used within RejectModalProvider');
  }
  return context;
};

type RejectModalProviderProps = {
  children: ReactNode;
};

export const RejectModalProvider = ({ children }: RejectModalProviderProps) => {
  const [rejectIsOpen, openRejectModal, closeRejectModal] = useModal();
  const [rejectModalProps, setRejectModalProps] = useState<RejectModalProps>(
    {}
  );

  const openReject = (props?: RejectModalProps) => {
    setRejectModalProps(props || {});
    openRejectModal();
  };

  const closeReject = () => {
    closeRejectModal();
    setRejectModalProps({});
  };

  return (
    <RejectModalContext.Provider
      value={{ rejectIsOpen, openReject, closeReject, rejectModalProps }}
    >
      {children}
    </RejectModalContext.Provider>
  );
};
